import { Popover } from '@mui/material';

const CommonPopover = ({ anchorEl, setAnchorEl, children, ...props }) => {
    const open = Boolean(anchorEl);

    return (
        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={() => {
                setAnchorEl(null);
            }}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
            PaperProps={{
                sx: {
                    minWidth: '70px',
                    display: 'flex',
                    flexDirection: 'column',
                },
            }}
            {...props}
        >
            {children}
        </Popover>
    );
};

export default CommonPopover;
